import { Box, Button } from "@mui/material"
import Icon from "src/@core/components/icon"

interface StepNavigationButtonsProps {
    handleNext?: () => void,
    handlePrev?: () => void,
    handleSubmit?: () => void,
    submit?: boolean
}

const ICON_NEXT = <Icon icon='mdi:chevron-right' fontSize={20} />
const ICON_PREV = <Icon icon='mdi:chevron-left' fontSize={20} />
const ICON_SUBMIT = <Icon icon='mdi:chevron-right' fontSize={20} />

const StepNavigationButtons = (props: StepNavigationButtonsProps) => {

    const { handleNext, handlePrev, handleSubmit, submit } = props

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',

                ...(!handlePrev && { flexDirection: 'row-reverse' }),
                width: '100%',
            }}
        >
            {
                handlePrev &&
                <Button color='secondary' variant='contained' onClick={handlePrev} startIcon={ICON_PREV}>
                    Atrás
                </Button>
            }
            {
                handleNext ?
                    <Button variant='contained' color='primary' onClick={handleNext} endIcon={ICON_NEXT}>
                        Siguiente
                    </Button> :
                    submit ? <Button variant='contained' color='primary' endIcon={ICON_NEXT} type='submit'>
                        Siguiente
                    </Button> :
                    handleSubmit &&
                    <Button variant='contained' color='success' onClick={handleSubmit} endIcon={ICON_SUBMIT}>
                        Finalizar
                    </Button>
            }
        </Box >
    )
}

export default StepNavigationButtons